// import { CommonModule } from '@angular/common';
// import {
//   OnInit,
//   AfterViewInit,
//   Component,
//   EventEmitter,
//   HostBinding,
//   Input,
//   Output,
//   ViewChild,
// } from '@angular/core';
// import { NgModule } from '@angular/core';
// import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
// import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { MatButtonModule } from '@angular/material/button';
// import { MatFormFieldModule } from '@angular/material/form-field';
// import { MatInputModule } from '@angular/material/input';

// import { AuthHttpService } from '@ib-core/services/auth-http.service';
// import { AbstractBaseComponent } from '@ib-shared/abstract/abstract-base';
// import { TranslocoRootModule } from '@ib-shared/transloco-root';
// import { TranslocoPipe } from '@ngneat/transloco';
// import { CodeInputComponent } from 'angular-code-input';
// import { CodeInputModule } from 'angular-code-input';
// import { SERVER_CUSTOM_ERRORS } from 'credebt-shared';
// import * as dayjs from 'dayjs';

// import { BtnWrapModule } from '../btn-wrap/btn-wrap.module';
// import { InputErrorModule } from '../input-error/input-error.module';
// import { IbSpinnerModule } from '../spinner/spinner.module';
// import { TimeDiffModule } from '../time-diff/time-diff.module';
// import { TooltipModule } from '../tooltip/tooltip.module';

// @Component({
//   selector: 'ib-code-input-wrap',
//   templateUrl: './code-input-wrap.component.html',
// })
// export class CodeInputWrapComponent
//   extends AbstractBaseComponent
//   implements AfterViewInit, OnInit
// {
//   @Input() parentForm!: FormGroup;
//   @Input() formCtrl!: FormControl;
//   @Input() abstractFormCtrl!: AbstractControl;
//   @Input() phoneId!: string;
//   @Input() phone: string;
//   @Input() phoneCountry: string;
//   @Input() validDuringSec?: number; // during this time code is valid after creation
//   @Input() disabled?: boolean;
//   @Input() isPhoneConfirmed?: boolean;
//   @Input() sendCodeLoading?: boolean;
//   @Input() codeExpireAt: dayjs.Dayjs | null;

//   public code: string;
//   public checkCodeLoading: boolean;
//   public codeError: string;
//   public codeLength = 6;
//   public tooltipTimeout: ReturnType<typeof setTimeout>;

//   public blockUiError: SERVER_CUSTOM_ERRORS;
//   public SERVER_CUSTOM_ERRORS = SERVER_CUSTOM_ERRORS;
//   public errorsForBlockUi = [
//     SERVER_CUSTOM_ERRORS.PHONE_TOO_MANY_ATTEMPTS_SEND_CODE,
//     SERVER_CUSTOM_ERRORS.PHONE_TOO_MANY_ATTEMPTS_CONFIRM_CODE,
//     SERVER_CUSTOM_ERRORS.PHONE_REGIST_VALIDATE_PHONE_LOOKS_LIKE_FRAUD,
//     SERVER_CUSTOM_ERRORS.PHONE_RECENT_ATTEMPT_TO_VALIDATE_PHONE,
//   ];

//   get isCodeConfirmed(): boolean {
//     return this.formCtrl?.value;
//   }
//   get isClearAvailable(): boolean {
//     return (
//       !this.isCodeConfirmed &&
//       this.code?.length === this.codeLength &&
//       !this.checkCodeLoading
//     );
//   }
//   get isResendAvailable(): boolean {
//     return !this.isCodeConfirmed && !this.codeExpireAt;
//   }
//   get isTooltipAvailable(): boolean {
//     return this.codeExpireAt && !this.isCodeConfirmed;
//   }

//   @ViewChild('codeInput', { static: false }) codeInput: CodeInputComponent;

//   @HostBinding('class') get classes(): string {
//     return [this.codeError ? 'ib-code-input-wrap--wrong-code' : ''].join(' ');
//   }

//   @Output() phoneConfirmed = new EventEmitter<{ phoneId: string }>();
//   @Output() resendCode = new EventEmitter<void>();

//   constructor(
//     private authHttpS: AuthHttpService,
//     private translate: TranslocoPipe,
//   ) {
//     super();
//   }

//   ngOnInit(): void {
//     this.codeCompleted('123456');
//   }

//   ngAfterViewInit(): void {
//     setTimeout(() => {
//       this.codeInput.focusOnField(0);
//     }, 500);
//   }

//   codeCompleted(code: string): void {
//     this.code = code;
//     this.checkCodeLoading = true;
//     this.authHttpS
//       .checkSecureCode({
//         phone: this.phone,
//         phoneCountry: this.phoneCountry,
//         code,
//       })
//       .subscribe({
//         next: res => {
//           console.log('res phone id', res);
//           this.formCtrl.setValue(true);
//           this.checkCodeLoading = false;

//           this.phoneConfirmed?.emit({ phoneId: res.phoneData.id });
//         },
//         error: err => {
//           this.codeError = this.translate.transform(
//             'comp.comfirm-sms.wrong-code',
//           );
//           this.formCtrl.setValue(false);
//           this.checkCodeLoading = false;
//           this.handleErrorForBlockUi(err);
//         },
//       });
//   }

//   private handleErrorForBlockUi(err): void {
//     if (
//       err?.error?.message &&
//       this.errorsForBlockUi.includes(err.error.message)
//     ) {
//       this.blockUiError = err?.error?.message;
//     } else {
//       this.blockUiError = undefined;
//     }
//   }

//   clearInput(): void {
//     this.code = undefined;
//     this.codeError = undefined;
//     this.codeInput.reset();
//     this.codeInput.focusOnField(0);
//   }

//   clearCode(): void {
//     this.code = undefined;
//     this.codeError = undefined;
//     this.codeExpireAt = undefined;
//     this.codeInput.reset();
//     this.codeInput.focusOnField(0);
//   }
// }
// @NgModule({
//   declarations: [CodeInputWrapComponent],
//   imports: [
//     CommonModule,
//     MatFormFieldModule,
//     MatInputModule,
//     FormsModule,
//     MatButtonModule,
//     ReactiveFormsModule,
//     IbSpinnerModule,
//     CodeInputModule,
//     TranslocoRootModule,
//     InputErrorModule,
//     TooltipModule,
//     TimeDiffModule,
//     BtnWrapModule,
//   ],
//   exports: [CodeInputWrapComponent],
// })
// export class CodeInputWrapModule {}
import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { NgModule } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { AuthHttpService } from '@ib-core/services/auth-http.service';
import { AbstractBaseComponent } from '@ib-shared/abstract/abstract-base';
import { TranslocoRootModule } from '@ib-shared/transloco-root';
import { TranslocoPipe } from '@ngneat/transloco';
import { CodeInputComponent } from 'angular-code-input';
import { CodeInputModule } from 'angular-code-input';
import { SERVER_CUSTOM_ERRORS } from 'credebt-shared';
import * as dayjs from 'dayjs';

import { BtnWrapModule } from '../btn-wrap/btn-wrap.module';
import { InputErrorModule } from '../input-error/input-error.module';
import { IbSpinnerModule } from '../spinner/spinner.module';
import { TimeDiffModule } from '../time-diff/time-diff.module';
import { TooltipModule } from '../tooltip/tooltip.module';

@Component({
  selector: 'ib-code-input-wrap',
  templateUrl: './code-input-wrap.component.html',
})
export class CodeInputWrapComponent
  extends AbstractBaseComponent
  implements AfterViewInit
{
  @Input() parentForm!: FormGroup;
  @Input() formCtrl!: FormControl;
  @Input() abstractFormCtrl!: AbstractControl;
  @Input() phoneId!: string;
  @Input() phone: string;
  @Input() phoneCountry: string;
  @Input() validDuringSec?: number; // during this time code is valid after creation
  @Input() disabled?: boolean;
  @Input() isPhoneConfirmed?: boolean;
  @Input() sendCodeLoading?: boolean;
  @Input() codeExpireAt: dayjs.Dayjs | null;

  public code: string;
  public checkCodeLoading: boolean;
  public codeError: string;
  public codeLength = 6;
  public tooltipTimeout: ReturnType<typeof setTimeout>;

  public blockUiError: SERVER_CUSTOM_ERRORS;
  public SERVER_CUSTOM_ERRORS = SERVER_CUSTOM_ERRORS;
  public errorsForBlockUi = [
    SERVER_CUSTOM_ERRORS.PHONE_TOO_MANY_ATTEMPTS_SEND_CODE,
    SERVER_CUSTOM_ERRORS.PHONE_TOO_MANY_ATTEMPTS_CONFIRM_CODE,
    SERVER_CUSTOM_ERRORS.PHONE_REGIST_VALIDATE_PHONE_LOOKS_LIKE_FRAUD,
    SERVER_CUSTOM_ERRORS.PHONE_RECENT_ATTEMPT_TO_VALIDATE_PHONE,
  ];

  get isCodeConfirmed(): boolean {
    return this.formCtrl?.value;
  }
  get isClearAvailable(): boolean {
    return (
      !this.isCodeConfirmed &&
      this.code?.length === this.codeLength &&
      !this.checkCodeLoading
    );
  }
  get isResendAvailable(): boolean {
    return !this.isCodeConfirmed && !this.codeExpireAt;
  }
  get isTooltipAvailable(): boolean {
    return this.codeExpireAt && !this.isCodeConfirmed;
  }

  @ViewChild('codeInput', { static: false }) codeInput: CodeInputComponent;

  @HostBinding('class') get classes(): string {
    return [this.codeError ? 'ib-code-input-wrap--wrong-code' : ''].join(' ');
  }

  @Output() phoneConfirmed = new EventEmitter<{ phoneId: string }>();
  @Output() resendCode = new EventEmitter<void>();

  constructor(
    private authHttpS: AuthHttpService,
    private translate: TranslocoPipe,
  ) {
    super();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.codeInput.focusOnField(0);
    }, 500);
  }

  codeCompleted(code: string): void {
    this.code = code;
    this.checkCodeLoading = true;
    this.authHttpS
      .checkSecureCode({
        phoneId: this.phoneId,
        phone: this.phone,
        phoneCountry: this.phoneCountry,
        code,
      })
      .subscribe({
        next: res => {
          this.formCtrl.setValue(true);
          this.checkCodeLoading = false;
          this.phoneConfirmed?.emit({ phoneId: res.phoneId });
        },
        error: err => {
          this.codeError = this.translate.transform(
            'comp.comfirm-sms.wrong-code',
          );
          this.formCtrl.setValue(false);
          this.checkCodeLoading = false;
          this.handleErrorForBlockUi(err);
        },
      });
  }

  private handleErrorForBlockUi(err): void {
    if (
      err?.error?.message &&
      this.errorsForBlockUi.includes(err.error.message)
    ) {
      this.blockUiError = err?.error?.message;
    } else {
      this.blockUiError = undefined;
    }
  }

  clearInput(): void {
    this.code = undefined;
    this.codeError = undefined;
    this.codeInput.reset();
    this.codeInput.focusOnField(0);
  }

  clearCode(): void {
    this.code = undefined;
    this.codeError = undefined;
    this.codeExpireAt = undefined;
    this.codeInput.reset();
    this.codeInput.focusOnField(0);
  }
}
@NgModule({
  declarations: [CodeInputWrapComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    ReactiveFormsModule,
    IbSpinnerModule,
    CodeInputModule,
    TranslocoRootModule,
    InputErrorModule,
    TooltipModule,
    TimeDiffModule,
    BtnWrapModule,
  ],
  exports: [CodeInputWrapComponent],
})
export class CodeInputWrapModule {}
